import type { ReactNode } from "react";
import { APP_NAME, SUPPORT_EMAIL } from "../lib/env";
import { ConfigBanner } from "./ConfigBanner";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps): JSX.Element {
  return (
    <div className="page">
      <header className="page__header" role="banner">
        <span className="page__brand">{APP_NAME}</span>
      </header>
      <main className="page__main" role="main">
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <ConfigBanner />
          {children}
        </div>
      </main>
      <footer className="page__footer" role="contentinfo">
        <span>
          © {new Date().getFullYear()} {APP_NAME}
        </span>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="page__footer-link">
          {SUPPORT_EMAIL}
        </a>
      </footer>
    </div>
  );
}
